function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21 0H3a2.969 2.969 0 00-3 3v13.5a2.969 2.969 0 003 3h18a2.969 2.969 0 003-3V3a2.969 2.969 0 00-3-3zm.45 5.1l-9 6.75a.75.75 0 01-.9 0l-9-6.75a.75.75 0 01.9-1.2L12 10.312 20.55 3.9a.75.75 0 01.9 1.2z",
  fill: "#D3D2CE"
});

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyMCI+PHBhdGggZD0iTTIxIDBIM2EyLjk2OSAyLjk2OSAwIDAwLTMgM3YxMy41YTIuOTY5IDIuOTY5IDAgMDAzIDNoMThhMi45NjkgMi45NjkgMCAwMDMtM1YzYTIuOTY5IDIuOTY5IDAgMDAtMy0zem0uNDUgNS4xbC05IDYuNzVhLjc1Ljc1IDAgMDEtLjkgMGwtOS02Ljc1YS43NS43NSAwIDAxLjktMS4yTDEyIDEwLjMxMiAyMC41NSAzLjlhLjc1Ljc1IDAgMDEuOSAxLjJ6IiBmaWxsPSIjRDNEMkNFIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=";
export { SvgMail as ReactComponent };